// React:
import React from "react";
// MUI Components:
import { Container } from "@mui/material";
// Components:
import DownloadBox from "./download-box/DownloadBox";
import BackgroundAnimation from "../global/background-animation/BackgroundAnimation";
// MUI Styles:
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  downloadContainer: {
    width: "100vw",
    height: "100vh",
    color: theme.palette.text.secondary,
    overflow: "hidden",
    position: "relative",
  },
}));

const Download = () => {
  const classes = useStyles();

  return (
    <Container
      maxWidth={false}
      sx={{ display: "flex", p: { xs: 0 } }}
      className={classes.downloadContainer}
    >
      <BackgroundAnimation />

      <DownloadBox />
    </Container>
  );
};

export default Download;
